import { render, staticRenderFns } from "./HomeBodyFourth.vue?vue&type=template&id=64fae944&scoped=true"
import script from "./HomeBodyFourth.vue?vue&type=script&lang=js"
export * from "./HomeBodyFourth.vue?vue&type=script&lang=js"
import style0 from "./HomeBodyFourth.vue?vue&type=style&index=0&id=64fae944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fae944",
  null
  
)

export default component.exports